import React from 'react'
import { useNavigate } from 'react-router-dom'
import '../assets/css/footer.css'

const Footer = ({ language }) => {
  const navigate = useNavigate()
  const handleNavigation = (e, screen) => {
    e.preventDefault()
    navigate(`/${screen}`)
  }
  return (
    <footer className='footer'>
        <div className='flex justify-between items-center logo-sec'>
          <a href='#home' onClick={e => handleNavigation(e, 'home')}>
            <img
              src={require('../assets/images/logo.png')}
              alt='Logo'
              className='logo'
            />
          </a>
        </div>
        <div className='footer-links opacity-75 text-sm'>
          <a href='#home' onClick={e => handleNavigation(e, 'home')}>
            {language === 'en' ? 'HOME' : 'หน้าแรก'}
          </a>
          {/* <a href='#about' onClick={e => handleNavigation(e, 'about')}>
            {language === 'en' ? 'ABOUT US' : 'เกี่ยวกับเรา'}
          </a> */}
          <a href='#projects' onClick={e => handleNavigation(e, 'projects')}>
            {language === 'en' ? 'PROJECTS' : 'โครงการ'}
          </a>
          <a href='#contact' onClick={e => handleNavigation(e, 'contact')}>
            {language === 'en' ? 'CONTACT' : 'ติดต่อ'}
          </a>
        </div>
        <div className='footer-credit'>
          <p className='text-sm opacity-50'>
            &copy; 2021 All Rights Reserved. Designed by Commons Core Co.,Ltd.
          </p>
        </div>
    </footer>
  )
}
export default Footer
